<template>
  <div class="mc-checkout">
    <div class="mc-container">
      <div v-if="orderLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="orderError" class="mc-form__message mc-form__message--alert" v-html="orderError"></div>
      <form v-if="orderLoaded && order.BASKET_ITEMS.length > 0" @submit.prevent="save" class="mc-checkout__form mc-form" id="checkoutForm" method="post" autocomplete="off">
        <fieldset class="mc-form__fieldset">
          <div class="mc-form__fieldset-title">
            Доставка
          </div>
          <div class="mc-form__field">
            <label class="mc-form__label" for="deliveryAddressCity">
              Населенный пункт
            </label>
            <div class="mc-form__search-wrapper" :class="{isFilled:cities.length > 0, isResultShown:cities.length > 0}">
              <div class="mc-form__search">
                <input type="hidden" v-model="property['6']">
                <input @input="searchCity" class="mc-form__search-input js-input-search" id="deliveryAddressCity" type="text" :value="property_formated['6']">
                <button class="mc-form__search-button-delete js-button-delete" type="button">
                  <svg class="mc-form__search-icon-delete" width="20" height="20" viewBox="0 0 20 20">
                    <use xlink:href="/assets/svg/sprite.svg#icon-cross-1"></use>
                  </svg>
                </button>
              </div>
              <div class="mc-form__search-result mc-search-result">
                <div class="mc-search-result__inner">
                  <ul class="mc-search-result__list">
                    <li v-for="city in cities" class="mc-search-result__item">
                      <a @click="selectCity(city)" class="mc-search-result__link">
                        {{ city.DISPLAY }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-form__radio-group">
            <div class="mc-form__radio-group-title">
              Способ доставки
              <span class="mc-form__asterisk">*</span>
            </div>
            <ul class="mc-form__radio-list">
              <li v-for="item in order.DELIVERY"  :key="'deliveryTypeKey'+item.ID" :class="{isActive: delivery == item.ID}" class="mc-form__radio-item">
                {{!delivery && item.CHECKED=='Y'?delivery=item.ID:''}}
                <div class="mc-form__radio-field">
                  <input class="mc-form__radio-input js-radio-input" :id="'deliveryType'+item.ID" :value="item.ID" type="radio" v-model="delivery">
                  <label class="mc-form__radio-label" :for="'deliveryType'+item.ID">
                    {{ item.NAME }}
                  </label>
                </div>
                <div class="mc-form__radio-content" v-if="delivery == item.ID">
                  <div class="mc-form__radio-note">
                    Стоимость: {{ item.PRICE_FORMATED }}<br>
                    <span v-html="item.DESCRIPTION"></span>
                  </div>
                  <div class="mc-form__radio-note" v-if="pickupPoint && item.ID == 62">
                    Адрес
                    <p class="mc-form__note-address">
                      {{pickupPoint}}
                    </p>
                  </div>
                  <button @click="pickup=true" v-if="item.ID == 62" :class="{'mc-button--color':!pickupPoint}" class="mc-button  simulated-hover js-modal-button" data-target="selectOffices" type="button">
                                            <span class="mc-button__text">
                                                Выбрать пункт самовывоза
                                            </span>
                  </button>
                  <template v-if="item.ID !=62" v-for="item_prop in order.ORDER_PROP.RELATED">
                  <div v-if="checkRelation(item_prop.RELATION)" class="mc-form__field">
                    <label class="mc-form__label" :for="'property'+item_prop.ID">
                      {{ item_prop.NAME }}
                      <span v-if="item_prop.REQUIRED=='Y'" class="mc-form__asterisk">*</span>
                    </label>
                    <input class="mc-form__input" :id="'property'+item_prop.ID" :required="item_prop.REQUIRED=='Y'" type="text" v-model="property[item_prop.ID]">
                  </div>
                  </template>
                </div>
              </li>
            </ul>
          </div>
        </fieldset>
        <fieldset class="mc-form__fieldset mc-form__fieldset--second">
          <div class="mc-form__fieldset-title">
            Оплата
          </div>
          <div class="mc-form__radio-group">
            <ul class="mc-form__radio-list">
              <li v-for="item in order.PAY_SYSTEM" :key="'paymentTypeKey'+item.ID" class="mc-form__radio-item">

                <div class="mc-form__radio-field">
                  <input class="mc-form__radio-input" :id="'paymentType'+item.ID" :value="item.ID" type="radio" v-model="payment">
                  <label class="mc-form__radio-label" :for="'paymentType'+item.ID">
                    {{ item.NAME }}
                    <span v-if="false && item.ID==17" class="mc-color">
                                                -5%
                                            </span>
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </fieldset>
        <fieldset class="mc-form__fieldset mc-form__fieldset--second">

          <div class="mc-form__fieldset-title">
            Ваши данные
          </div>
          <template v-for="item in order.ORDER_PROP.PRINT">
          <div class="mc-form__field" v-if="!['5', '6', '7'].includes(item.ID)">
            <label class="mc-form__label" :for="'property'+item.ID">
              {{ item.NAME }}
              <span class="mc-form__asterisk">*</span>
            </label>
            <MaskInput v-if="item.ID==3" class="mc-form__input" :id="'property'+item.ID" type="tel" v-model="property[item.ID]" :value="property[item.ID]" placeholder="+7 (___) ___-__-__" required mask="+7 (###) ###-##-##"  />
            <input v-else class="mc-form__input" :id="'property'+item.ID" :type="item.ID==2?'email':'text'" v-model="property[item.ID]" placeholder="" required>
          </div>
            <div v-if="item.ID==2" class="mc-form__field">
              <input class="mc-form__checkbox" type="checkbox" v-model="subscribe" id="checkbox" >
              <label class="mc-form__label" for="checkbox">
                Подписаться на рассылку
              </label>
            </div>
          </template>
        </fieldset>
        <fieldset class="mc-form__fieldset">
          <div class="mc-form__field">
            <label class="mc-form__label" for="checkoutFormComment">
              Комментарий
            </label>
            <input class="mc-form__input" id="checkoutFormComment" type="text" v-model="comment" placeholder="">
          </div>
        </fieldset>
        <div class="mc-calculation">
          <div class="mc-calculation__item">
                            <span class=" mc-calculation__cell">
                                Товаров на сумму
                            </span>
            <span class="mc-calculation__cell">
                                {{ order.PRICE_WITHOUT_DISCOUNT_VALUE }} ₽
                            </span>
          </div>
          <div v-if="order.BASKET_PRICE_DISCOUNT_DIFF_VALUE > 0" class="mc-calculation__item">
                            <span class="mc-calculation__cell">
                                Скидка
                            </span>
            <span class="mc-calculation__cell">
                                -{{ order.BASKET_PRICE_DISCOUNT_DIFF_VALUE }} ₽
                            </span>
          </div>
          <div class="mc-calculation__item">
                            <span class="mc-calculation__cell">
                                Доставка
                            </span>
            <span class="mc-calculation__cell">
                                {{ order.DELIVERY_PRICE }} ₽
                            </span>
          </div>
          <div class="mc-calculation__item mc-calculation__item--big">
                            <span class="mc-calculation__cell">
                                Итого
                            </span>
            <span class="mc-calculation__cell">
                                {{ order.ORDER_PRICE + order.DELIVERY_PRICE }} ₽
                            </span>
          </div>
        </div>
        <div v-if="isAuth && bonus" class="mc-form__info">
          <div class="mc-calculation">
            <div class="mc-calculation__item">
                                <span class=" mc-calculation__cell">
                                    Ваши баллы
                                </span>
              <span class="mc-calculation__cell">
                                    {{ bonus.bonus }}
                                </span>
            </div>
          </div>
          <p>
            Списание баллов осуществляется при подтверждении заказа менеджером интернет-магазина.
          </p>
        </div>
        <div class="mc-form__info">
          <p>
            При заказе шести и более единиц или на сумму свыше 120 000 ₽ возможна только онлайн-оплата.
          </p>
          <p>
            Одному клиенту не отправляются два и более размера одного товара. Уточнить размеры вы можете у менеджеров интернет-магазина.
          </p>
          <p>
            Обращаем ваше внимание на то, что имея на доставке незавершенный заказ, следующий ваш заказ, может быть отправлен только после полной оплаты. В ином случае ваш заказ не перейдет в статус сборки.
          </p>
        </div>
        <div v-for="item in order.ERROR" class="mc-message mc-message--alert">
                        <span class="mc-message__content">
                            {{ item }}
                        </span>
        </div>
        <div class="mc-form__info">
          <p>
            Нажимая на кнопку "Завершить оформление" вы принимаете условия <router-link to="/page/oferta/">Публичной оферты</router-link>
          </p>
        </div>
        <div class="mc-form__bottom">
          <button class="mc-button mc-button--color simulated-hover" type="submit">
                            <span class="mc-button__text">
                                Завершить оформление
                            </span>
          </button>
        </div>
      </form>
      <div v-if="orderLoaded && order.BASKET_ITEMS.length == 0">
        <p>Для ооформления заказа добавьте товары в корзину</p>
        <router-link to="/catalog/" class="mc-outfit__cta-button mc-button simulated-hover">Перейти в каталог</router-link>
      </div>
    </div>
  </div>

  <Pickup v-if="pickup" :key="property[6]" :city="this.property_formated[6]" :isOpen="pickup" @close="pickupSelect"></Pickup>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash';
import axios from 'axios';
import Pickup from './blocks/Pickup.vue';
import ProductStore from "@/views/blocks/ProductStore.vue";
import { MaskInput } from 'vue-3-mask';

export default {
  data: () => ({
   delivery: false,
    payment: false,
    property: {},
    property_formated: {},
    comment: '',
    subscribe: false,
    cities: [],
    pickup: false,
    pickupPoint: '',
    ss: ''
  }),
  watch: {
    delivery(newValue, oldValue) {
      if (oldValue != false)
        this.reload();
    },
    payment(newValue, oldValue) {
      if (oldValue != false)
        this.reload();
    },
    success(newValue, oldValue) {
      if (newValue == 'Y')
        this.$router.push(this.redirect.replace("/api/order/", "/order/success/"))
    }
  },
  mounted() {

  },
  async created() {
    await this.fetchOrder();
    for (let i in this.order.ORDER_PROP.RELATED) {
      if (this.order.ORDER_PROP.RELATED[i])
        this.property[this.order.ORDER_PROP.RELATED[i].ID] = this.order.ORDER_PROP.RELATED[i].VALUE;
    }
    for (let i in this.order.ORDER_PROP.USER_PROPS_N) {
      if (this.order.ORDER_PROP.USER_PROPS_N[i])
        this.property[i] = this.order.ORDER_PROP.USER_PROPS_N[i].VALUE;
    }
    for (let i in this.order.ORDER_PROP.USER_PROPS_Y) {
      if (this.order.ORDER_PROP.USER_PROPS_Y[i]) {
        this.property[i] = this.order.ORDER_PROP.USER_PROPS_Y[i].VALUE;
        if (this.order.ORDER_PROP.USER_PROPS_Y[i].IS_LOCATION == 'Y') {
          for (let j in this.order.ORDER_PROP.USER_PROPS_Y[i].VARIANTS) {
            if (this.order.ORDER_PROP.USER_PROPS_Y[i].VARIANTS[j].ID == this.order.ORDER_PROP.USER_PROPS_Y[i].VALUE)
              this.property_formated[i] = this.order.ORDER_PROP.USER_PROPS_Y[i].VARIANTS[j].CITY_NAME;
          }
        }
        else
        this.property_formated[i] = this.order.ORDER_PROP.USER_PROPS_Y[i].VALUE_FORMATED;
      }
    }

    this.initPayment();
  },
  computed: {
    ...mapGetters([
      'order',
      'orderLoading',
      'orderError',
      'orderLoaded',
        'success',
        'redirect',
        'isAuth',
        'bonus'
    ]),
  },
  components: {ProductStore, Pickup, MaskInput},
  methods: {
    ...mapActions([
      'fetchOrder',
      'reloadOrder',
        'saveOrder'
    ]),
    checkRelation(items) {
      for (let i in items) {
        if (items[i].ENTITY_TYPE == 'D' && items[i].ENTITY_ID == this.delivery)
          return true;
      }
      return false;
    },
    initPayment() {
      if (this.order.PAY_SYSTEM?.length) {
        const defaultPayment = this.order.PAY_SYSTEM.find(item => item.CHECKED === 'Y');
        if (defaultPayment) {
          this.payment = defaultPayment.ID;
        }
      }
    },
    async reload() {
      let data = {
        is_ajax_post: 'Y',
        json: 'Y',
        save: 'Y',
        confirmorder: 'N',
        PERSON_TYPE: 1,
        ORDER_DESCRIPTION: this.comment,
        SUBSCRIBE: this.subscribe
      }
      data.DELIVERY_ID = this.delivery;
      data.PAY_SYSTEM_ID = this.payment;
      console.log(this.property)
      for (let i in this.property) {
        data['ORDER_PROP_' + i] = this.property[i]
      }
      //data['ORDER_PROP_6'] = 84
      console.log(data)
      await this.reloadOrder(data);
      for (let i in this.order.ORDER_PROP.RELATED) {
        if (this.order.ORDER_PROP.RELATED[i])
          this.property[this.order.ORDER_PROP.RELATED[i].ID] = this.order.ORDER_PROP.RELATED[i].VALUE;
      }
      this.initPayment();
    },
    async save() {
      let data = {
        is_ajax_post: 'Y',
        json: 'Y',
        save: 'Y',
        confirmorder: 'Y',
        PERSON_TYPE: 1,
        ORDER_DESCRIPTION: this.comment,
        SUBSCRIBE: this.subscribe?'Y':'N'
      }
      data.DELIVERY_ID = this.delivery;
      data.PAY_SYSTEM_ID = this.payment;
      console.log(this.property)
      for (let i in this.property) {
        data['ORDER_PROP_' + i] = this.property[i]
      }
      //data['ORDER_PROP_6'] = 84
      console.log(data)
      await this.saveOrder(data);
      this.scrollToFirstError();
      this.initPayment();
    },
    searchCity2: function () {
      //this.ss = this.property_formated['6'];
    },
    searchCity(evt)  {
      this.property_formated['6'] = evt.target.value;
      this.actionSearchCity();
    },
    actionSearchCity: debounce(async function()  {
      const response = await axios.post('api/order/location/', {
        'select[1]': 'CODE',
        'select[2]': 'TYPE_ID',
        'select[VALUE]': 'ID',
        'select[DISPLAY]': 'NAME.NAME',
        'additionals[1]': 'PATH',
        'filter[=PHRASE]': this.property_formated['6'],
        'filter[=NAME.LANGUAGE_ID]': 'ru',
        'filter[=SITE_ID]': 's1',
        version: 2,
        PAGE_SIZE: 10,
        PAGE: 0,
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      this.cities = response.data.data
     /* else
        this.cities = [];*/
    }, 300),
    selectCity(city) {
      this.cities = [];
      this.property['6'] = city['VALUE'];
      this.property_formated['6'] = city['DISPLAY'];
      this.reload();
    },
    pickupSelect(item, key, city) {
      console.log(item, key, city);
      this.pickup = false;
      if (!item)
        return;
      //console.log(item)
      this.property[7] = city+", "+item.Address+' #S'+item.key;
      this.property[78] = city+", "+item.Address+' #S'+item.key;
      this.pickupPoint = item.Name;
      console.log(this.property[7]);

    },
    scrollToFirstError() {
      this.$nextTick(() => {
        // Find first error element or server error message
        let firstErrorElement;
        if (document.querySelector('.mc-form__message--alert'))
        firstErrorElement = document.querySelector('.mc-form__message--alert');
        if (document.querySelector('.mc-message--alert'))
          document.querySelector('.mc-message--alert');
        if (firstErrorElement) {
          // Scroll to the element with smooth behavior
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },
  },
}
</script>

